/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AwardWalletSyncResponse
 */
export interface AwardWalletSyncResponse {
    /**
     * Server timestamp recorded when the sync task was queued. Clients
     * poll the connection endpoint until `last_synced_at` is greater
     * than this value (or `last_sync_error` is set) to detect completion.
     * 
     * @type {Date}
     * @memberof AwardWalletSyncResponse
     */
    requestedAt: Date;
}

/**
 * Check if a given object implements the AwardWalletSyncResponse interface.
 */
export function instanceOfAwardWalletSyncResponse(value: object): value is AwardWalletSyncResponse {
    if (!('requestedAt' in value) || value['requestedAt'] === undefined) return false;
    return true;
}

export function AwardWalletSyncResponseFromJSON(json: any): AwardWalletSyncResponse {
    return AwardWalletSyncResponseFromJSONTyped(json, false);
}

export function AwardWalletSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AwardWalletSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'requestedAt': (new Date(json['requested_at'])),
    };
}

export function AwardWalletSyncResponseToJSON(json: any): AwardWalletSyncResponse {
    return AwardWalletSyncResponseToJSONTyped(json, false);
}

export function AwardWalletSyncResponseToJSONTyped(value?: AwardWalletSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requested_at': value['requestedAt'].toISOString(),
    };
}

